import axios from "axios"
import { getToken } from '../utils/storage'

export const getBaseURL = () => {
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
   }

    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname.startsWith("10.") || hostname.startsWith("192.")) {
        return "http://localhost:5000/api";
    }

    return "https://backend-sjup.onrender.com/api";
};

const API = axios.create({
    baseURL: getBaseURL()
})

// ✅ Add Request Interceptor for Authentication
API.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default API